/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyDogecoin = createReactComponent("outline", "currency-dogecoin", "IconCurrencyDogecoin", [["path", { "d": "M6 12h6", "key": "svg-0" }], ["path", { "d": "M9 6v12", "key": "svg-1" }], ["path", { "d": "M6 18h6a6 6 0 1 0 0 -12h-6", "key": "svg-2" }]]);

export { IconCurrencyDogecoin as default };
//# sourceMappingURL=IconCurrencyDogecoin.mjs.map
